import { inputStyles } from '../Input';

export default function FilterWrapper(props: Component.DefaultProps) {
  return <div className={inputStyles.wrapper.filterWrapper} children={props.children} style={props.style}/>;
}
